var TemperatureUnit_1;
import { __decorate } from "tslib";
import { Unit } from './Unit';
import { SerializableObject } from '../../data/decorators';
/**
 * @category Unit
 */
let TemperatureUnit = TemperatureUnit_1 = class TemperatureUnit extends Unit {};
TemperatureUnit.CELCIUS = new TemperatureUnit_1('celcius', {
  baseName: 'temperature'
});
TemperatureUnit.FAHRENHEIT = new TemperatureUnit_1('fahrenheit', {
  baseName: 'temperature',
  definitions: [{
    unit: 'celcius',
    offset: -32,
    magnitude: 5 / 9
  }]
});
TemperatureUnit.KELVIN = new TemperatureUnit_1('kelvin', {
  baseName: 'temperature',
  definitions: [{
    unit: 'celcius',
    offset: -273.15
  }]
});
TemperatureUnit.RANKINE = new TemperatureUnit_1('rankine', {
  baseName: 'temperature',
  definitions: [{
    unit: 'kelvin',
    magnitude: 1 / 1.8
  }]
});
TemperatureUnit = TemperatureUnit_1 = __decorate([SerializableObject()], TemperatureUnit);
export { TemperatureUnit };